import {
  FC,
  JSX,
  useState
} from "react";
import { View, TouchableOpacity } from "react-native";
import Clipboard from "@react-native-clipboard/clipboard";
import { Tooltip } from "react-native-paper";
import CopyToClipboardIcon from "@/assets/icons/main/copyToClipboard.svg";
import useShowToaster from "@/_hooks/Toasters/useShowToaster";

interface ICopyToClipboardProps {
  text: string;
}

const CopyToClipboard: FC<ICopyToClipboardProps> = ({ text }): JSX.Element => {
  const [isCopied, setIsCopied] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const showToaster = useShowToaster();

  const handleCopy = async (): Promise<void> => {
    try {
      Clipboard.setString(text);
      setIsCopied(true);
      setError(null);
      setTimeout(() => setIsCopied(false), 1000);
      showToaster({
        message: "Скопировано!"
      })

    } catch (err: any) {
      const errorMessage = err?.message || "Не удалось скопировать";
      setError(errorMessage);
      showToaster({
        message: errorMessage
      })
    }
  };

  return (
    <View className="flex-row items-center justify-center">
      <Tooltip
        title={error || (isCopied ? "Скопировано!" : "Копировать")}
        enterTouchDelay={0}
        leaveTouchDelay={0}
      >
        <TouchableOpacity onPress={handleCopy} accessibilityLabel="Скопировать в буфер обмена">
          <CopyToClipboardIcon width={20} height={20} />
        </TouchableOpacity>
      </Tooltip>
    </View>
  );
};

export default CopyToClipboard;
